/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import PropTypes from "prop-types";
import media from "../../../../styles/customMedia.json";
import classnames from "classnames";
import styles from "./index.css";

const [[largeMinWidth], [mediumMinWidth]] = ["large", "medium"].map(viewPort =>
  media.customMedia[`--${viewPort}-viewport`].match(/(\(min-width: [^)]+\))/)
);

const ProductImage = ({
  imageUrl,
  className,
  onMouseOver,
  onMouseLeave,
  onError,
  onLoad,
  onTransitionEnd
}) => (
  <img
    className={classnames(className, styles.fillParent)}
    src={`//${imageUrl}?$n_480w$&wid=476&fit=constrain`}
    srcSet={[
      [240, 238],
      [320, 317],
      [480, 476],
      [640, 634],
      [750, 714],
      [960, 952]
    ]
      .map(
        ([presetSize, ourSize]) =>
          `//${imageUrl}?$n_${presetSize}w$&wid=${ourSize}&fit=constrain ${ourSize}w`
      )
      .join(",")}
    sizes={`${largeMinWidth} 300px, ${mediumMinWidth} 312px, 227px`}
    alt=""
    onMouseOver={onMouseOver}
    onMouseLeave={onMouseLeave}
    onError={onError}
    onLoad={onLoad}
    onTransitionEnd={onTransitionEnd}
  />
);

ProductImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  className: PropTypes.string,
  onMouseOver: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  onTransitionEnd: PropTypes.func
};

export default ProductImage;
